// extracted by mini-css-extract-plugin
module.exports = {"barHolder":"CircularProgressbar_barHolder__3M72F","text":"CircularProgressbar_text__O8QfP","zero":"CircularProgressbar_zero__2XDU-","check":"CircularProgressbar_check__1vj5J"};